var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("Tesorería")]),_c('h5',[_vm._v("Cuentas")]),_c('router-link',{attrs:{"to":"/admin/tesoreria/saldos"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"}},[_vm._v("Saldos de familias")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }